module.exports = __webpack_public_path__ + "img/rcn.a0e822ad.svg";